import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { AppHeader } from "@/components/AppHeader";
import { AuthProvider } from "@/contexts/AuthContext";
import Auth from "./pages/Auth";
import Suporte from "./pages/Suporte";
import AdminConvites from "./pages/AdminConvites";
import AdminDashboard from "./pages/AdminDashboard";
import AdminConversas from "./pages/AdminConversas";
import AdminConhecimento from "./pages/AdminConhecimento";
import AdminPipelines from "./pages/AdminPipelines";
import AdminLeads from "./pages/AdminLeads";
import AdminTreinamentos from "./pages/AdminTreinamentos";
import Artigo from "./pages/Artigo";
import Ajuda from "./pages/Ajuda";
import Topico from "./pages/Topico";
import SearchResults from "./pages/SearchResults";
import NotFound from "./pages/NotFound";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { LanguageProvider } from "@/contexts/LanguageContext";

const App = () => (
  <AuthProvider>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <LanguageProvider>
        <ErrorBoundary>
          <Routes>
    
            {/* Páginas públicas — sem sidebar */}
            <Route path="/" element={<Ajuda />} />
            <Route path="/ajuda" element={<Ajuda />} />
            <Route path="/suporte" element={<Suporte />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/search" element={<SearchResults />} />
                    {/* Rotas de conteúdo primeiro */}
            <Route path="/artigo/:id" element={<Artigo />} />
            <Route path="/topicos" element={<Topico />} />
            <Route path="/topicos/:id" element={<Topico />} />
            {/* Área administrativa — com sidebar */}
            <Route path="/admin/*" element={
              <SidebarProvider>
                <div className="min-h-screen flex w-full bg-background">
                  <AppSidebar />
                  <div className="flex-1 flex flex-col">
                    <AppHeader />
                    <main className="flex-1 p-3 sm:p-4 md:p-6">
                      <Routes>
                        <Route path="dashboard" element={<AdminDashboard />} />
                        <Route path="conversas" element={<AdminConversas />} />
                        <Route path="conhecimento" element={<AdminConhecimento />} />
                        <Route path="treinamentos" element={<AdminTreinamentos />} />
                        <Route path="pipelines" element={<AdminPipelines />} />
                        <Route path="leads" element={<AdminLeads />} />
                        <Route path="convites" element={<AdminConvites />} />
                        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                      </Routes>
                    </main>
                  </div>
                </div>
              </SidebarProvider>
            } />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </ErrorBoundary>
        </LanguageProvider>
      </BrowserRouter>
    </TooltipProvider>
  </AuthProvider>
);

export default App;
